module.exports = __webpack_public_path__ + "img/02web-other.9c39bfe8.png";